// var module = angular.module('Directives');


angular.module('Directives').directive('ngAmCharts', function ($timeout, $document) {
    var baseParams = {
        "export": {
            "enabled": true,
            "menu": [
                {
                    label: false,
                    class: "export-main",
                    menu: [
                        {
                            label: 'Download as...',
                            menu: ["PNG", "JPG", "SVG", "PDF"]
                        },
                        {
                            label: 'Annotate...',
                            action: 'draw'
                        },
                        {
                            format: 'PRINT',
                            label: 'Print'
                        }
                    ]
                }
            ]
        },
        balloon: {
            borderThickness: 1,
            shadowAlpha: 0,
            animationDuration: 0,
            fadeOutDuration: 0.1
        },
        marginTop: 0,
        marginLeft: 0,
        creditsPosition: "bottom-right",
        fontFamily: '"Ubuntu", sans-serif',
        fontSize: 10,
        color: 'rgba(128, 128, 128, 0)'
    };


    var chartScrollbar = {
        scrollbarHeight: 50,
        backgroundColor: "#888888",
        graphLineColor: '#0085c2',
        graphFillColor: '#0085c2',
        backgroundAlpha: 0.1,
        graphFillAlpha: 0.2,
        graphLineAlpha: 0.3,
        updateOnReleaseOnly: true,
        selectedBackgroundColor: "#888888",
        selectedGraphLineColor: '#0085c2',
        selectedGraphFillColor: '#0085c2',
        selectedBackgroundAlpha: 0.15,
        selectedGraphFillAlpha: 0.4,
        selectedGraphLineAlpha: 0.6,
        autoGridCount: true,
        graph: 'monthly1',
        fontSize: 11,
        color: '#666666',
        selectedColor: '#000000',
        dragIcon: 'dragIconRectSmall',
        dragIconHeight: 50,
        accessibleLabel: 'Adjust timeline range'
    };


    return {
        restrict: 'A',
        scope: {
            ngAmCharts: '=',
            ngAmChartsOptions: '='
        },
        link: function ($scope, element) {
          //$scope.$watch('ngAmCharts', function(){
            $timeout(function(){
              var chartOptions = {};
              if($scope.ngAmCharts){
                $scope.ngAmCharts.chartScrollbar = $scope.ngAmCharts.chartScrollbar ? angular.copy(chartScrollbar) : false;
                $scope.ngAmCharts = angular.extend(chartOptions, angular.copy(baseParams), $scope.ngAmCharts);
                if ($scope.ngAmCharts.chartScrollbar && element.is('.scrolling-chart')) {
                    var withTooltipElements;
                    $scope.ngAmCharts.listeners = $scope.ngAmCharts.listeners || [];
                    $scope.ngAmCharts.listeners.push(
                        {
                            "event": "drawn",
                            "method": function(event) {
                                withTooltipElements ? withTooltipElements.baseTooltip('action', 'off') : false;
                                withTooltipElements = angular.element('g[aria-label]', element).baseTooltip({
                                    labelText: 'aria-label',
                                    addClass: 'chart-scroll',
                                    marginTop: $scope.ngAmCharts.chartScrollbar.dragIconHeight,
                                    marginLeft: $scope.ngAmCharts.chartScrollbar.dragIconWidth / 2
                                });
                                var removeTooltips = function() {
                                    withTooltipElements ? withTooltipElements.baseTooltip('action', 'off') : false;
                                };
                                $scope.$on('$routeChangeStart', removeTooltips);
                            }

                        }
                    );
                }

                if($scope.ngAmCharts.dataProvider.length === 0) {
                    let chart = AmCharts.makeChart(element.get(0), {
                        "type": "serial",
                        "dataProvider": [],
                        "valueAxes": [],
                        "graphs": [{
                            "balloonText": "Income in [[category]]:[[value]]",
                            "fillAlphas": 1,
                            "lineAlpha": 0.2,
                            "title": "Income",
                            "type": "column",
                            "valueField": "income",
                            "labelText": "[[value]]",
                            "labelPosition": "middle",
                            
                        }],
                        "color" : "rgba(128, 128, 128, 0)",
                        "fontFamily" : "'Open Sans', 'Helvetica Neue', Helvetica, sans-serif",
                        "depth3D": 20,
                        "angle": 30,
                        "rotate": true,
                        "categoryField": "year",
                        "categoryAxis": {
                            "gridPosition": "start",
                            "fillAlpha": 0.05,
                            "position": "left"
                        }
                    });
                    chart.valueAxes[0].minimum = 0;
                    chart.valueAxes[0].maximum = 100;
                    var dataPoint = {dummyValue: 0};
                    dataPoint[chart.categoryField] = '';
                    chart.dataProvider = [dataPoint];
                    chart.addLabel(0, '50%', 'NO DATA AVAILABLE', 'center',12, '#3a404f');
                    chart.validateNow();
                } else {
                    $scope.ngAmCharts.renderedChart = AmCharts.makeChart(element.get(0), $scope.ngAmCharts);
                }

                if($scope.ngAmChartsOptions && $scope.ngAmChartsOptions.listenScrollTo){
                    $scope.$on('afterScrollChart', function(event, data){
                          $scope.ngAmCharts.renderedChart.zoomToIndexes(data.chart.startIndex, data.chart.endIndex);
                    });
                }
                
                
                if($scope.ngAmChartsOptions && $scope.ngAmChartsOptions.legend && $scope.ngAmChartsOptions.legend.title){
                    (function(){
                        var title = $document.createElement("div");
                        title.innerHTML = "$scope.ngAmChartsOptions.legend.title";
                        title.className = "legend-title";
                        e.chart.legendDiv.appendChild(title);
                    })();
                }
              }
            })
          //})
        }
    }
});



// WEBPACK FOOTER //
// ./js/directives/ngAmCharts.js